import { Span } from '@afterpaytouch/core'
import { useTranslation } from 'next-i18next'
import React, { FunctionComponent } from 'react'
import styles from './style.module.css'
import { useCheckoutSizes } from '../../utils/responsive'

export const PaymentMethodNoCard: FunctionComponent = () => {
  const { t } = useTranslation()
  const { textSize } = useCheckoutSizes()

  return (
    <span className={styles.container}>
      <span className={styles.textContainer}>
        <Span size={textSize} bold>
          {t('common:changePaymentMethod')}
        </Span>
      </span>
    </span>
  )
}
